import './ProgressHeader.css'
import { translations } from '../../data/translations'

const ProgressHeader = ({ progress, language }) => {
  const t = translations[language] || translations.de

  return (
    <section className="progress-header" aria-label={t.ui.progressAriaLabel}>
      <div className="progress-header__container">
        <div className="progress-header__progress">
          <div className="progress-header__label">
            {t.ui.progressLabel}: <strong>{Math.round(progress)}%</strong>
          </div>
          <div className="progress-header__bar">
            <div 
              className="progress-header__fill"
              style={{ width: `${progress}%` }}
              role="progressbar"
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProgressHeader
